import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ApiService from "./../../services/api-service";
import "./index.scss";
import { fullName, isOwnerId } from "../../constants/function";
import Loader from "../Loader";
import { Images } from "../../assets/common";
import LockIcon from "@mui/icons-material/Lock";
import notifier from "../Notifier";

export default function ChatUserSearch(props) {
  const [keyWords, setKeyWords] = React.useState("");
  const [users, setUsers] = React.useState([]);
  const [playlists, setPlaylists] = React.useState([]);

  const [loading, setLoading] = React.useState(false);
  const typingTimer = React.useRef(null);
  const doneTypingInterval = 1000; // time in ms

  const onKeyup = (e) => {
    const value = e.target.value;
    if (typingTimer.current) {
      clearTimeout(typingTimer.current);
    }
    typingTimer.current = setTimeout(() => doneTyping(value), doneTypingInterval);
  };
  const onkeydown = (e) => {
    if (typingTimer.current) {
      clearTimeout(typingTimer.current);
    }
  };
  //user is "finished typing," do something
  async function doneTyping(keyWords) {
    if (keyWords.trim() !== "") {
      try {
        setLoading(true);
        searchPlaylist(keyWords);
        const response = await ApiService.SEARCH_USER(keyWords);

        setUsers([...response["result"]]);

        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  }
  const searchPlaylist = async (searchTerm) => {
    try {
      setLoading(true);
      const response1 = await ApiService.SEARCH_PLAYLIST(searchTerm);
      setPlaylists([...response1["result"]]);
      // const b = document.getElementById("__search_input_box");
      // b.blur();
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  React.useEffect(() => {
    // doneTyping("A");
    return () => {
      if (typingTimer.current) {
        clearTimeout(typingTimer.current);
      }
      setKeyWords("");
      setUsers([]);
      setPlaylists([]);
    };
  }, []);

  const handleClick = (userName, userId, user, playlistId) => {
    props.handleClose(userName, userId, user, playlistId);
  };
  return (
    <Box className="__chat_userlist_container">
      <Box className="__chat_userlist_header">
        <Typography
          className="fs-16"
          sx={{ color: "var(--text-primary, #FFFFFF)" }}
        >
          New message
        </Typography>
        <CloseIcon
          className="_cp"
          onClick={() =>
            props.handleClose(
              props["userName"],
              props["senderUserId"],
              props["newUser"]
            )
          }
          color="default"
        />
      </Box>
      <Box className="_chat_user_search">
        <input
          id="__search_input_box"
          aria-label="search user"
          value={keyWords}
          onChange={(e) => setKeyWords(e.target.value)}
          onKeyUp={(e) => onKeyup(e)}
          onKeyDown={(e) => onkeydown(e)}
          className="fs-14 _chat_user_search_input"
          type="text"
          placeholder="Search user by name, studio name"
          autoComplete="off"
          autoFocus
        />
        <SearchIcon
          className="_chat_user_search_icon"
          sx={{ color: "var(--text-secondary, #676767)" }}
        />
      </Box>

      <Stack
        spacing={1}
        sx={{ padding: "10px 15px", maxHeight: "85%", overflow: "scroll" }}
      >
        <Stack spacing={1}>
          {users &&
            users.map((user, index) =>
              props["userId"] !== user["_id"] ? (
                <Stack
                  onClick={() => handleClick(fullName(user), user["_id"], user)}
                  key={index}
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  className="_cp"
                >
                  <img
                    className="avatar"
                    src={
                      user["profileImg"] &&
                      user["profileImg"]["filePath"] !== ""
                        ? user["profileImg"]["filePath"]
                        : Images.default_user
                    }
                    alt={user["firstName"]}
                  />
                  <Typography
                    className="fs-14 "
                    sx={{ color: "var(--text-primary, #FFFFFF)" }}
                  >
                    {fullName(user)}
                  </Typography>
                </Stack>
              ) : null
            )}
        </Stack>
        <Stack spacing={1}>
          {playlists.length > 0 ? (
            <Stack>
              <Typography
                className="fs-16"
                sx={{ color: "var(--text-primary, #FFFFFF)" }}
              >
                Playlists
              </Typography>
              <Divider sx={{ borderColor: "rgba(var(--text-primary-rgb, 255, 255, 255), 0.12)" }} />
            </Stack>
          ) : null}

          {playlists &&
            playlists.map((playlist, index) =>
              props["playlistId"] !== playlist["_id"] ? (
                <Stack
                  onClick={() => {
                    !isOwnerId(playlist["createdBy"]) &&
                    playlist["private"] &&
                    !playlist["isSubscribed"]
                      ? notifier.error(
                          "Subscribe the artist to access private assets"
                        )
                      : handleClick(
                          playlist["title"],
                          playlist["_id"],
                          playlist,
                          playlist["_id"]
                        );
                  }}
                  key={index}
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  className="_cp"
                >
                  <img
                    className="avatar"
                    src={
                      playlist["GIF"] &&
                      !playlist["GIF"]["filePath"].includes(undefined)
                        ? playlist["GIF"]["filePath"]
                        : playlist["thumbnailImg"]
                        ? playlist["thumbnailImg"]["filePath"]
                        : Images.user_dummy
                    }
                    alt={playlist["title"]}
                  />
                  <Typography
                    className="fs-14 "
                    sx={{ color: "var(--text-primary, #FFFFFF)" }}
                  >
                    {playlist["title"]}
                  </Typography>
                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ marginLeft: 0 }}
                  >
                    {playlist["private"] ? (
                      <LockIcon className="__small_icon" />
                    ) : null}
                    {playlist["nftId"] ? (
                      <img style={{ width: "1rem" }} src={Images.NFT} />
                    ) : null}
                  </Stack>
                </Stack>
              ) : null
            )}
        </Stack>
      </Stack>

      {loading ? <Loader wait={true} _class="__loader_inside" /> : null}
    </Box>
  );
}
